import React from 'react'
import { Alert, Button, Card, Col, Modal, Row } from 'react-bootstrap'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import {
  getMonthStringList,
  i18nTranslate,
  enablePhoneVerificationInProfileUpdate,
  emailValidation,
  isFeatureEnabled,
} from 'src/utils'
import {
  accountsContainer,
  customerContainer,
  storeContainer,
} from 'src/models'
import { languageAbbreviation } from 'src/views/pages/LoginCallback/fixture.js'
import { getLocaleCodeFromUrl, trackMyProfileEvents } from 'src/utils'
import { CommonForm } from 'src/views/components'
import {
  parsePhoneNumberField,
  validLibMobilePhoneNumber,
} from 'src/utils/signUpUtils'
import { pageNames } from 'src/routes/pathParams'
import { BsFillExclamationCircleFill } from 'react-icons/bs'
import { getReadOnlyFields } from 'src/utils/signUpUtils'
import { countryData } from 'src/views/components/SignUpForms/countryCodeData'
import { getDateFromString, getParsedPhoneNumber } from 'src/utils'
import { EmailNotVerifiedSMSVerify } from 'src/views/components/CommonForm/EmailNotVerifiedSMSVerify'
import { PhoneNotVerified } from 'src/views/components/CommonForm/PhoneNotVerified'
import { PhoneVerified } from 'src/views/components/CommonForm/PhoneVerified'
import { PhoneVerificationModal } from 'src/views/components/PhoneVerificationModal/PhoneVerificationModal'
import { APPConfig } from 'config/appConfig'
import { EmailVerifiedSMSVerify } from 'src/views/components/CommonForm/EmailVerifiedSMSVerify'

@observer
class AccountFormSMSverify extends React.Component {
  @observable showPopup = false
  @observable formData = []
  @observable isEditProfile = false
  @observable profileDataVal = []
  @observable setCheckPhoneVal = {}
  @observable isEmailFormatValid = true
  @observable isPhoneFormatValid = true

  // *** ADD THIS observable for screen reader live message ***
  @observable editProfileLiveMessage = ''

  FORM = 'FORM'
  POPUP = 'POPUP'
  SUBMIT_BUTTON = 'SUBMIT_BUTTON'
  EMAIL_VERIFIED = 'EMAIL_VERIFIED'
  EDIT_BUTTON = 'EDIT_BUTTON'
  CANCEL_BUTTON = 'CANCEL_BUTTON'
  VERIFY_BUTTON = 'VERIFY_BUTTON'

  constructor(props) {
    super(props)
    this.profileData()
  }

  handleProcess = async (formData = {}) => {
    const prefName = formData.preferredName
    let response = {}
    if (prefName === '') {
      response =
        await customerContainer.updateProfileWithoutPreferredName(formData)
    } else {
      response = await customerContainer.updateProfile(formData)
      accountsContainer.isSaveChangesBtnClicked = true
    }
    if (accountsContainer.isSuccessResponse(response)) {
      this.props.onUpdate()
      this.handleCancelProfile()
      customerContainer.triggerSaveChangesOnPhoneVerifySuccess = false
    }
  }

  handleUpdateForm = async () => {
    await this.props.onUpdate()
    await this.profileData()
  }

  componentDidUpdate() {
    if (accountsContainer.isSaveChangesBtnClicked) {
      accountsContainer.isSaveChangesBtnClicked = false
      this.props.onUpdate()
    }
  }

  customHandleBlur = async ({ values = {} }) => {
    if (values.mobilePhoneNumber !== '') {
      const phoneNumberCode = await parsePhoneNumberField(
        values.mobilePhoneNumber,
        values.phoneCountryCode
      )
      const isValidMobile = await validLibMobilePhoneNumber(phoneNumberCode)
      accountsContainer.phoneNumberIsValid = isValidMobile
    }
    if (values.email != '') {
      accountsContainer.duplicateEmailExist = false
    }
  }

  handleSubmit = formData => {
    const isPhoneVerified = enablePhoneVerificationInProfileUpdate()
      ? this.setCheckPhoneVal?.phoneCountryCode ===
          customerContainer?.setVerifyPhone?.phoneCountryCode &&
        this.setCheckPhoneVal?.phoneNumber ===
          customerContainer?.setVerifyPhone?.phoneNumber
      : true

    if (isPhoneVerified) {
      this.handleSavechanges(formData)
    } else {
      typeof this.props.getFormRefData === 'function' &&
        this.props.getFormRefData(formData)
      customerContainer.triggerSaveChangesOnPhoneVerifySuccess = true
      customerContainer.verifyPhonePopup = true
    }
  }

  handleSavechanges = formData => {
    const { email, preferredLanguage } = formData
    const exEmail = customerContainer.profileResponse?.email || ''
    const exPreferredLanguage =
      customerContainer?.profileResponse?.customProperties?.preferredLanguage ||
      ''

    /**
     * @info
     * GTM Datalayer - Send event if user updates/changes communication/preferred language.
     */
    if (preferredLanguage !== exPreferredLanguage) {
      const { b2bMyProfile } = pageNames
      trackMyProfileEvents({
        type: 'nuskin-profile',
        categoryName: 'communications',
        eventName: 'Profile - Communication Lang Update',
        preferences: {
          preferredLanguage:
            languageAbbreviation[preferredLanguage.trim()] || '',
        },
      })
      // TagManager.dataLayer({
      //   dataLayer: {
      //     event: 'NuskinProfileCommunicationLangUpdate',
      //     pagePath: b2bMyProfile,
      //     exPreferredLanguage,
      //     newPreferredLanguage: preferredLanguage,
      //     userDetails: {
      //       userId: customerContainer.profileResponse?.id || '',
      //       email: customerContainer.profileResponse?.email || '',
      //       firstName: customerContainer.profileResponse?.firstName || '',
      //       lastName: customerContainer.profileResponse?.lastName || '',
      //     },
      //     pageTitle: 'My Profile',
      //     platform: 'equinox',
      //   },
      // })
    }
    if (email === exEmail) {
      this.handleProcess(formData)
    } else {
      this.showPopup = true
      this.formData = { ...formData }
    }
    this.profileData()
  }

  handleClosePopup = () => {
    this.showPopup = false
  }

  handleSubmitPopup = () => {
    this.showPopup = false
    this.handleProcess(this.formData)
  }

  getDataModal(dataKey) {
    switch (dataKey) {
      case this.FORM:
        return {
          label: this.props?.label || '',
          schema: this.props?.schema,
          formInput: this.props?.formInput,
          dataTestId: this.props?.dataTestId || '',
          classNameValue: {
            formRowClassName: 'shadow-sm form-card bg-white',
          },
        }
      case this.SUBMIT_BUTTON:
        return {
          label: this.props?.button?.label || '',
          dataTestId: this.props?.button?.dataTestId || '',
          message: i18nTranslate(
            'myprofile.submit.message',
            'Please switch to your home market to make any changes.'
          ),
        }
      case this.EDIT_BUTTON:
        return {
          label: this.props?.editButton?.label || '',
          dataTestId: this.props?.editButton?.dataTestId || '',
          message: i18nTranslate(
            'myprofile.submit.message',
            'Please switch to your home market to make any changes.'
          ),
        }
      case this.CANCEL_BUTTON:
        return {
          label: this.props?.cancelButton?.label || '',
          dataTestId: this.props?.cancelButton?.dataTestId || '',
        }
      case this.VERIFY_BUTTON:
        return {
          label: this.props?.verifyButton?.label || '',
          dataTestId: this.props?.verifyButton?.dataTestId || '',
        }
      case this.POPUP:
        return {
          modalTitle: i18nTranslate('emailUpdate', 'Email Update'),
          changeEmailMessage1: i18nTranslate(
            'changeEmailmsg1',
            "You are changing account's primary email for account correspondence and used for logging in."
          ),
          changeEmailMessage2: i18nTranslate(
            'changeEmailmsg2',
            'Are you sure you want to save changes?'
          ),
          proceedText: i18nTranslate('myprofile.proceed', 'Proceed'),
        }
      case this.EMAIL_VERIFIED:
        return {
          message: i18nTranslate(
            'myprofile.emailAlert',
            'Please verify your email address.'
          ),
        }
      default:
        return {}
    }
  }

  getStyleGuides(dataKey) {
    switch (dataKey) {
      case this.FORM:
        return {
          classNameValue: {
            formRowClassName: 'mb-2 mb-md-3',
          },
        }
      case this.SUBMIT_BUTTON:
        let homeCountry = storeContainer.currentRegion || ''

        customerContainer?.profileResponse?.accounts?.properties?.forEach(
          (element = {}) => {
            if (element.attributeId === 'countryCode') {
              homeCountry = element.value
            }
          }
        )

        if (homeCountry === 'CA') {
          homeCountry = 'Canada'
        }

        return {
          showMessageClass:
            homeCountry === storeContainer.storeIDValue ? '' : 'd-none',
          hideMessageClass:
            homeCountry === storeContainer.storeIDValue
              ? 'd-none'
              : 'non-home-market-country',
        }
      case this.EMAIL_VERIFIED:
        const isEmailVerifiedFlag =
          customerContainer?.profileResponse?.customProperties
            ?.isEmailVerifiedFlag == 'false' || false
        const isEmailVerifiedRegionSpecific =
          APPConfig?.getAppConfig()?.enableEmailVerifiedMessage || []
        // const homeMarket = getLocalStorage('homeCountry') || ''
        const homeMarket = customerContainer.getUserHomeCountry()
        const curLocale =
          getLocaleCodeFromUrl({
            defaultLocale: 'en_US',
            isReverseType: true,
          }) || ''

        const [language, activeCountry] = curLocale.includes('_')
          ? curLocale.split('_')
          : curLocale.split('-')

        return {
          hideMessageClass:
            isEmailVerifiedFlag &&
            isEmailVerifiedRegionSpecific?.includes(
              homeMarket?.toLowerCase()
            ) &&
            homeMarket?.toLowerCase() === activeCountry?.toLowerCase()
              ? 'alert-verify-text d-flex align-items-center font-weight-bold'
              : 'd-none',
        }
      default:
        return {}
    }
  }

  renderSubmitButton = () => {
    const data = this.getDataModal(this.SUBMIT_BUTTON)
    const cancelBtnData = this.getDataModal(this.CANCEL_BUTTON)
    const styles = this.getStyleGuides(this.SUBMIT_BUTTON)
    return (
      <div>
        <Col className={`${styles?.showMessageClass} text-center text-md-right`}>
          <Button
            variant="primary"
            type="submit"
            data-testid={data?.dataTestId}
            className="myaccount-btn mb-2 md-0">
            {data?.label}
          </Button>
        </Col>
        <Col className={`${styles?.showMessageClass} text-center text-md-right`}>
          <Button
            variant="light"
            type="button"
            onClick={() => {
              this.handleCancelProfile()
            }}
            data-testid={cancelBtnData?.dataTestId}
            className="myaccount-btn mb-2 md-0 border border-primary">
            {cancelBtnData?.label}
          </Button>
        </Col>
        {customerContainer.isProfileCallOver && (
          <div className={styles?.hideMessageClass}>{data?.message}</div>
        )}
      </div>
    )
  }

  handleEditProfile = () => {
    this.isEditProfile = true
    this.editProfileLiveMessage = i18nTranslate(
      'profile.editLiveMessage',
      'edit profile form is open'
    )
  }

  handleCancelProfile = () => {
    this.isEditProfile = false
    window.scrollTo(0, 0)
    this.profileData()
    customerContainer.setVerifyPhone.phoneCountryCode =
      this.setCheckPhoneVal?.phoneCountryCode
    customerContainer.setVerifyPhone.phoneNumber =
      this.setCheckPhoneVal?.phoneNumber
    // Optionally clear the screen reader message on cancel
    this.editProfileLiveMessage = ''
  }

  renderEditButton = () => {
    const data = this.getDataModal(this.EDIT_BUTTON)
    const styles = this.getStyleGuides(this.SUBMIT_BUTTON)
    return (
      <Row className="border-top">
        <Col className={styles?.showMessageClass}>
          <Button
            variant="primary"
            type="button"
            data-testid={data?.dataTestId}
            onClick={() => {
              this.handleEditProfile()
            }}
            className="myaccount-btn mt-4 mb-2 md-0">
            {data?.label}
          </Button>
        </Col>
        {customerContainer.isProfileCallOver && (
          <div className={styles?.hideMessageClass}>{data?.message}</div>
        )}
      </Row>
    )
  }

  renderPopup = () => {
    const data = this.getDataModal(this.POPUP)

    return (
      <div>
        <Modal
          show={true}
          onHide={this.handleClosePopup}
          backdrop="static"
          keyboard={false}
          className="modal_box">
          <Modal.Header closeButton>
            <Modal.Title className="text-center">
              {data?.modalTitle}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Alert className="loyaltyAlert" variant="danger">
              {data?.changeEmailMessage1} {data?.changeEmailMessage2}
            </Alert>
            <Button
              className="confirmBtn mb-2 ml-7"
              variant="primary"
              onClick={this.handleSubmitPopup}>
              {data?.proceedText}
            </Button>
          </Modal.Body>
        </Modal>
      </div>
    )
  }

  profileData = async () => {
    const userResponse = customerContainer.profileResponse || {}
    const isEmailVerified =
      userResponse?.customProperties?.isEmailVerifiedFlag || ''
    let showEmailVerificationStatus = ''
    if (isEmailVerified === 'true') {
      showEmailVerificationStatus = 'valEmail'
    } else {
      showEmailVerificationStatus = 'notValEmail'
    }
    const isPhoneNumberVerified =
      userResponse?.customProperties?.isPhoneNumberVerified || ''
    let showPhoneVerificationStatus = ''
    if (isPhoneNumberVerified === 'true') {
      showPhoneVerificationStatus = 'valPhone'
    } else {
      showPhoneVerificationStatus = 'notValPhone'
    }
    const acctype1 = userResponse?.accounts?.type || ''
    const firstName =
      acctype1 == 'Brand Affiliate - Business Entity'
        ? userResponse?.accounts?.name || ''
        : userResponse?.firstName || ''
    const lastName =
      acctype1 == 'Brand Affiliate - Business Entity'
        ? ''
        : userResponse?.lastName || ''
    const email = userResponse?.email || ''
    const phoneNumber = userResponse?.phoneNumber || ''

    //Start of parse phonenumber code
    const userCountry =
      userResponse?.accounts?.properties?.find(
        element => element.attributeId === 'countryCode'
      )?.value || ''
    const localCountry = userCountry
      ? userCountry
      : storeContainer?.storeIDValue === 'Canada'
        ? 'CA'
        : storeContainer?.storeIDValue

    let inputCode = countryData()?.find(
      element => element.value === localCountry
    )?.value
    let phoneNumberCode = ''
    let parsedPhoneNumber = ''
    if (phoneNumber) {
      let phoneCountry = ''
      parsedPhoneNumber = await getParsedPhoneNumber(phoneNumber)

      phoneNumberCode = parsedPhoneNumber?.phoneNumberCode
      if (phoneNumberCode === undefined) {
        phoneNumberCode = phoneNumber
      }
      phoneCountry = parsedPhoneNumber?.phoneCountry

      inputCode = phoneCountry || inputCode
    }
    let dob = getDateFromString(userResponse?.dateOfBirth)
    let formattedDob = ''
    if (dob?.date) {
      const locale = getLocaleCodeFromUrl()?.replace('_', '-') || 'en-US'
      const months = getMonthStringList(locale)
      const month = months[dob.date.getMonth()]
      const day = dob.date.getDate()
      const year = dob.date.getFullYear()
      formattedDob = `${month} ${day} ${year}`
    }
    const enableReadonlyFields = APPConfig?.getAppConfig()?.enableReadonlyFields
    const getlocal = getLocaleCodeFromUrl({
      defaultLocale: 'en_US',
      isReverseType: true,
    })
    const country = getlocal?.split('_').length ? getlocal?.split('_')[1] : ''
    const defaultLanguageCountries = getReadOnlyFields(
      'addressReadOnly',
      country
    )
    const isDefaultLanguage =
      enableReadonlyFields?.defaultLanguageReadOnly?.language || ''
    const preferredLanguage = defaultLanguageCountries
      ? isDefaultLanguage
      : userResponse?.customProperties?.preferredLanguage || ''
    const phoneNumberCodeVal = await parsePhoneNumberField(
      phoneNumber,
      inputCode
    )
    const phoneCode = phoneNumberCodeVal?.countryCallingCode
      ? '+' + phoneNumberCodeVal?.countryCallingCode
      : ''
    const lang = `accountProfile.${preferredLanguage.toLowerCase()}`
    const preferredLanguageTranslate = i18nTranslate(`${lang}`, 'English')

    // Validate phone number using the standard validation
    const isPhoneValid =
      phoneNumberCodeVal && Object.keys(phoneNumberCodeVal).length > 0
        ? await validLibMobilePhoneNumber(phoneNumberCodeVal)
        : true

    // Store validation results
    this.isEmailFormatValid = emailValidation(email)
    this.isPhoneFormatValid = isPhoneValid

    this.setCheckPhoneVal = {
      phoneCountryCode: inputCode,
      phoneNumber: phoneNumberCode,
    }

    this.profileDataVal = [
      {
        label: i18nTranslate('profileData.name', 'Name'),
        value: `${firstName} ${lastName}`,
        dataTestId: 'qa-profile-name',
      },
      ...(dob.date !== '' && formattedDob
        ? [
            {
              label: i18nTranslate('dateOfBirth', 'Date of Birth'),
              value: `${formattedDob}`,
            },
          ]
        : []),
      ...(phoneNumber && phoneNumberCode && phoneNumberCode.trim() !== ''
        ? [
            {
              label: i18nTranslate('profileData.phoneNumber', 'Phone Number'),
              phoneCountry: inputCode,
              value: `${phoneCode} ${phoneNumberCode}`,
              verifyStatus: showPhoneVerificationStatus,
              dataTestId: 'qa-profile-phone-number',
            },
          ]
        : []),
      {
        label: i18nTranslate('profileData.email', 'Email'),
        value: `${email}`,
        verifyStatus: showEmailVerificationStatus,
        dataTestId: 'qa-profile-email',
      },
      {
        label: i18nTranslate(
          'profileData.preferredLanguage',
          'Preferred Language'
        ),
        value: `${preferredLanguageTranslate}`,
        dataTestId: 'qa-preferred-language',
      },
    ]
  }

  compareUserHomeCountry() {
    let isUserHomeCountry = false
    const selectedLocaleCode = getLocaleCodeFromUrl()?.split('_')?.[1] || {}
    const eqMarketLocales = APPConfig?.getAppConfig()?.eqMarketLocales || ['US']
    let userCountry = customerContainer?.getUserHomeCountry() || ''

    if (selectedLocaleCode === 'undefined') {
      isUserHomeCountry = false
    } else if (selectedLocaleCode != userCountry) {
      isUserHomeCountry = false
    } else {
      isUserHomeCountry = eqMarketLocales?.includes(userCountry?.toLowerCase())
    }
    return isUserHomeCountry
  }

  renderProfileInfo = () => {
    const data = this.getDataModal(this.FORM)
    const verifyBtnData = this.getDataModal(this.VERIFY_BUTTON)

    return (
      <Card
        className="mb-3 shadow-sm profileDetailCont"
        data-testid={`${data?.dataTestId}-container`}>
        <Card.Body className="bg-white">
          <h1
            data-testid={`${data?.dataTestId}-heading`}
            className="card-title heading-2-bold card-title h5">
            {data?.label}
          </h1>

          {/* Common validation error message for email and phone */}
          {isFeatureEnabled('phoneEmailValidationInProfile') &&
            (!this.isEmailFormatValid || !this.isPhoneFormatValid) &&
            this.compareUserHomeCountry() && (
              <div className="validationPhoneEmailErrorContainer" role="alert">
                <BsFillExclamationCircleFill
                  size="1.2rem"
                  className="validationPhoneEmailErrorIcon"
                />
                {i18nTranslate(
                  'validationEmailAndPhoneInProfile',
                  'Email or phone number is invalid.'
                )}
              </div>
            )}

          {this.profileDataVal?.length > 0 &&
            this.profileDataVal?.map((item, index) => {
              if (!item?.value || item?.value === 'undefined') {
                return <></>
              }
              return (
                <Row key={index} className="mb-3">
                  <Col xs={12} className="">
                    <div className="d-flex">
                      <div
                        className={`profileDataLabel ${item?.label} font-weight-bold`}>
                        {item?.label}
                      </div>
                    </div>
                    <div className="d-flex">
                      <div
                        className="profileDataVal"
                        data-testid={item?.dataTestId ? item?.dataTestId : ''}>
                        {item?.value}
                      </div>
                      {/* {(item?.verifyStatus === 'valEmail' ||
                        item?.verifyStatus === 'valPhone') && (
                        <div className="verifySymbolCont ml-2">
                          <MdVerifiedUser
                            size="1rem"
                            className={`tick-icon green`}
                          />
                        </div>
                      )} */}
                      {/* {(item?.verifyStatus === 'notValEmail' ||
                        item?.verifyStatus === 'notValPhone') && (
                        <div className="verifySymbolCont ml-2">
                          <BsFillExclamationCircleFill
                            size="1rem"
                            className={`tick-icon red`}
                          />
                        </div>
                      )} */}
                    </div>
                    {item?.verifyStatus === 'notValEmail' &&
                      this.compareUserHomeCountry() && (
                        <form>
                          <EmailNotVerifiedSMSVerify />
                        </form>
                      )}
                    {item?.verifyStatus === 'valEmail' &&
                      this.compareUserHomeCountry() && (
                        <form>
                          <EmailVerifiedSMSVerify />
                        </form>
                      )}
                    {item.verifyStatus === 'valPhone' &&
                      this.compareUserHomeCountry() && (
                        <form>
                          <PhoneVerified />
                        </form>
                      )}
                    {item?.verifyStatus === 'notValPhone' &&
                      this.compareUserHomeCountry() && (
                        <>
                          <form>
                            <PhoneNotVerified />
                          </form>
                          {/* <Button
                          variant="light"
                          type="button"
                          onClick={() => {
                            this.handlePhoneVerify()
                          }}
                          data-testid={verifyBtnData?.dataTestId}
                          className="myaccount-btn my-2 md-0 border border-primary">
                          {verifyBtnData?.label}
                        </Button> */}
                        </>
                      )}
                  </Col>
                </Row>
              )
            })}
          {this.renderEditButton()}
        </Card.Body>
      </Card>
    )
  }

  handlePhoneVerify = () => {
    typeof this.props.getFormRefData === 'function' &&
      this.props.getFormRefData()
    customerContainer.verifyPhonePopup = true
  }

  renderEditProfile = () => {
    const data = this.getDataModal(this.FORM)
    const emailVerifyData = this.getDataModal(this.EMAIL_VERIFIED) || {}
    const emailVerifyStyle = this.getStyleGuides(this.EMAIL_VERIFIED) || {}
    return (
      <div
        className="mb-3 profileInfoContainer"
        data-testid={`${data?.dataTestId}-container`}>
        {this.showPopup && this.renderPopup()}
        {customerContainer?.isProfileCallOver && (
          <div className={emailVerifyStyle?.hideMessageClass}>
            <BsFillExclamationCircleFill
              size="1rem"
              className={`tick-icon red`}
            />
            <span>{emailVerifyData?.message}</span>
          </div>
        )}

        {data?.formInput?.length > 0 && (
          <CommonForm
            schema={data?.schema}
            formTypeJson={data?.formInput}
            reference={this.props.formRef}
            SubmitButtonProps={this.renderSubmitButton}
            customHandleBlur={this.customHandleBlur}
            onSubmit={this.handleSubmit}
            hasInlineSubmitButton={false}
            classNameValue={data?.classNameValue}
          />
        )}
      </div>
    )
  }

  renderContent = () => {
    return this.isEditProfile ? (
      <>{this.renderEditProfile()}</>
    ) : (
      <>{this.renderProfileInfo()}</>
    )
  }

  render() {
    return (
      <>
        <div
          aria-live="assertive"
          aria-atomic="true"
          style={{
            position: 'absolute',
            width: '1px',
            height: '1px',
            margin: '-1px',
            border: '0',
            padding: '0',
            overflow: 'hidden',
            clip: 'rect(0 0 0 0)',
          }}>
          {this.editProfileLiveMessage}
        </div>
        {this.renderContent()}
        <PhoneVerificationModal
          showModal={customerContainer.verifyPhonePopup}
          profileDataPhone={this.setCheckPhoneVal}
          formData={this.props.phoneVerifyFormdata}
          onComplete={this.handleSavechanges}
          successUpdate={this.handleUpdateForm}
        />
      </>
    )
  }
}

export default AccountFormSMSverify
